module.exports = __webpack_public_path__ + "static/media/close_icon_competency.d33fc10a.svg";